import React, {Component} from 'react'
import Spinner from "../../../../../components/Spinnner/Spinner";
import {Link} from "react-router-dom";
import {BackFontAwesome, EditFontAwesome} from "../../../../../components/FontAwesomeComponent";
import {ViewComponentExternalLink} from "../../../../../components/CMSFormComponents";
import {facilitiesListPage} from "../../../../../constants/routesConstants";
import FacilitiesService from "../../../../../services/Shop/FacilityService";
import ArtistImage from "../../../../../components/ArtistItem/ArtistImage";

class FacilityDetail extends Component {

    state = {
        entity: null
    }

    componentDidMount() {
        FacilitiesService.getFacility(this.props.match.params.id).then(
            item => this.setState({entity: item.data})
        )
    }

    render() {
        if(!this.state.entity){
            return(
                <Spinner/>
            )
        }

        return (
            <div>
                <div className="card" style={{boxShadow: "5px 1px 12px rgba(0, 0, 0, 0.1)"}}>
                    <div className="card-body">
                        {this.state.entity.url && <div className="d-flex justify-content-center" style={{marginBottom: "20px"}}>
                            <ArtistImage photoUrl={this.state.entity.url} size={5} name={this.state.entity.url}/>
                        </div>}
                        <table className="table table-hover">
                            <tbody>
                            <tr>
                                <td scope="row">Id</td>
                                <th>{this.state.entity.id}</th>
                            </tr>
                            <tr>
                                <td scope="row">Name</td>
                                <th>{this.state.entity.name}</th>
                            </tr>
                            <tr>
                                <td scope="row">Disabled</td>
                                <th>{this.state.entity.disabled ? <span className="badge badge-danger">Yes</span> : <span className="badge badge-primary">No</span>}</th>
                            </tr>
                            </tbody>
                        </table>
                        <div style={{display: "flex", justifyContent: "space-evenly"}}>
                            <button onClick={() => this.props.history.goBack()} className="btn btn-secondary"><BackFontAwesome/> Back</button>
                            <Link to={`${this.props.match.url}/edit`}><button className="btn btn-warning"><EditFontAwesome/> Edit</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default FacilityDetail;